import React, { Fragment, useState, useEffect } from "react";
import {
  Grid,
  IconButton,
  Typography,
  Tab,
  Tabs,
  AppBar,
  Toolbar,
  Tooltip,
  Avatar,
} from "@mui/material";
import HazardMap from "../../assets/MAG_hazard_map.jpg";
import male_icon from "../../assets/male_icon.png";
import female_icon from "../../assets/female_icon.png";
import MenuIcon from "@mui/icons-material/Menu";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { SignInLogo } from "./SignInLogo";

import bgimage from "../../assets/mag_drone3.jpg";

import { CBEWSL_SITE_NAME } from "../../host";

const MainHeader = () => {
  let navigate = useNavigate();
  const [value, setValue] = useState(0);
  const [server_time, setServerTime] = useState("");
  const [profileIcon, setProfileIcon] = useState(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    switch (newValue) {
      case 0:
        navigate(`/plguopcen`);
        break;
    }
  };

  useEffect(() => {
    const data = localStorage.getItem("mag_credentials");
    const parse_data = JSON.parse(data);
    const user_sex = parse_data.user.sex;

    if (user_sex === "Male") {
      setProfileIcon(male_icon);
    } else {
      setProfileIcon(female_icon);
    }
  }, []);

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };
  const [anchorElSettings, setAnchorElSettings] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const openSettings = Boolean(anchorElSettings);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setAnchorElSettings(null);
  };

  const handleCurrentTab = () => {
    const path_name = window.location.pathname;
    if (path_name === `//plguopcen`) {
      setValue(0);
    } 
  };

  const handleOpen = () => {
    window.open(HazardMap, "_blank");
  };

  useEffect(() => {
    handleCurrentTab();
  });

  useEffect(() => {
    setInterval(() => {
      let dt = moment().format("ddd DD-MMM-YYYY hh:mm:ss A");
      setServerTime(dt);
    }, 1000);
  }, []);

  return (
    <Fragment>
      <Grid
        container
        spacing={0}
        style={{
          backgroundImage: `url(${bgimage})`,
          backgroundPosition: "center",
        }}
      >
        <Grid item
          xs={12}
          sm={4}
          md={4}
          lg={5}
        >
          <SignInLogo />
        </Grid>

        <Grid
          item
          xs={12}
          sm={6.5}
          md={6.5}
          lg={6}
          sx={{
            textAlign: "left",
            height: "100%",
            width: "100%",
          }}
        >
          <div
            style={{
              textAlign: "left",
              width: "100%",
              marginTop: 15,
            }}
          >
            <Typography
              style={{
                fontWeight: "600",
                fontSize: 28,
                color: "#FFFFFF",
                textShadow: "3px 3px #000000",
              }}
            >
              COMMUNITY-BASED EARLY WARNING SYSTEM FOR LANDSLIDES
            </Typography>
            <Typography
              variant="h5"
              style={{
                fontWeight: "600",
                color: "#FFFFFF",
                textShadow: "3px 3px #000000",
              }}
            >
              Brgy. Magsaysay, Kibawe, Bukidnon
            </Typography>
          </div>
        </Grid>

        <Grid
          item
          xs={12}
          sm={1.5}
          md={1.5}
          lg={1}
          sx={{
            textAlign: "left",
            height: "100%",
            width: "100%",
          }}
        >
          <div style={{ textAlign: "end" }}>
            <Tooltip title="Open settings">
              <IconButton
                onClick={(e) => {
                  setAnchorElSettings(e.currentTarget);
                }}
                sx={{ mt: 4 }}
              >
                <Avatar src={profileIcon} alt="Profile photo" />
              </IconButton>
            </Tooltip>

            <Menu
              id="menu-settings"
              anchorEl={anchorElSettings}
              open={openSettings}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "button",
              }}
            >
              <MenuItem
                onClick={() => {
                  navigate(`/profile-settings`);
                  handleClose();
                }}
              >
                Edit Profile
              </MenuItem>
              <MenuItem
                onClick={() => {
                  navigate(`/change-password`);
                  handleClose();
                }}
              >
                Change Password
              </MenuItem>
            </Menu>

            <IconButton
              id="button"
              aria-controls={open ? "menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
              sx={{ mt: 4 }}
            >
              <MenuIcon alt="Menu" style={{ color: "#FFFFFF" }} />
            </IconButton>
            <Menu
              id="menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "button",
              }}
            >
              <MenuItem
                onClick={() => {
                  navigate(`/feedback`);
                  handleClose();
                }}
              >
                Feedback
              </MenuItem>
              <MenuItem
                onClick={() => {
                  localStorage.removeItem("mag_credentials")(
                    (window.location = `/`)
                  );
                }}
              >
                Logout
              </MenuItem>
            </Menu>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            width: "100%",
          }}
        >
          <AppBar position="static" color="inherit">
            <Grid
              container
              style={{
                backgroundColor: "#006A91",
              }}
            >
              <Grid item md={10}>
                <Toolbar style={{ justifyContent: "center" }}>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    TabIndicatorProps={{
                      style: { background: "white" },
                    }}
                    aria-label="basic tabs example"
                  >
                    <Tab
                      disabled
                      label={
                        <span style={{ color: "white", fontWeight: "bold" }}>
                          DASHBOARD
                        </span>
                      }
                      {...a11yProps(0)}
                    />
                    <Tab
                      disabled
                      label={
                        <span>
                          GROUND DATA
                        </span>
                      }
                    />
                    <Tab
                      disabled
                      label={
                        <span>
                          DATA ANALYSIS
                        </span>
                      }
                    />
                    <Tab
                      disabled
                      label={
                        <span>
                          COMMUNITY RISK ASSESSMENT
                        </span>
                      }
                    />

                    <Tab
                      disabled
                      label={
                        <span>
                          SCHEDULE
                        </span>
                      }
                    />
                    <Tab style={{ display: "none" }} {...a11yProps(2)} />
                  </Tabs>
                </Toolbar>
              </Grid>
              <Grid item md={2} style={{ alignSelf: "center" }}>
                <Typography variant="body1" style={{ color: "white" }}>
                  {server_time.toUpperCase()}
                </Typography>
              </Grid>
            </Grid>
          </AppBar>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default MainHeader;
